import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../../featureFlags';
import { CAMPAIGN_PERMISSIONS } from 'dashboard/constants/permissions.js';

const campaigns = accountId => ({
  parentNav: 'campaigns',
  routes: ['ongoing_campaigns', 'one_off', 'mass_outbound'],
  menuItems: [
    {
      key: 'massOutboundCampaigns',
      icon: 'send',
      label: 'MASS_OUTBOUND',
      featureFlag: FEATURE_FLAGS.MASS_OUTBOUND,
      hasSubMenu: false,
      meta: {
        permissions: ['administrator', CAMPAIGN_PERMISSIONS],
      },
      toState: frontendURL(`accounts/${accountId}/campaigns/mass_outbound`),
      toStateName: 'mass_outbound',
    },
    {
      icon: 'arrow-swap',
      label: 'WEBSITE',
      key: 'ongoingCampaigns',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/ongoing`),
      toStateName: 'ongoing_campaigns',
    },
    {
      key: 'oneOffCampaigns',
      icon: 'sound-source',
      label: 'SMS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/one_off`),
      toStateName: 'one_off',
    },
  ],
});

export default campaigns;
